export const featuresState = state => state.features;